import {TextStyle, StyleSheet, Text} from "react-native";
import {useCurrentTheme} from "@/theming/useCurrentTheme";

export interface ErrorMessageProps {
    message?: string;
    style?: TextStyle;
    visible?: boolean;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
                                                              message,
                                                              style,
                                                              visible = true
                                                          }) => {
    const { theme } = useCurrentTheme();
    const styles = createStyles(theme);

    if (!message || !visible) return null;

    return (
        <Text style={[styles.errorText, style]}>
            {message}
        </Text>
    );
};

const createStyles = (theme: any) => StyleSheet.create({
    errorText: {
        color: theme.colors.error,
        fontSize: theme.fontSize.sm,
        textAlign: 'center',
        marginBottom: theme.spacing.md,
        backgroundColor: '#fff2f2',
        padding: theme.spacing.sm,
        borderRadius: theme.borderRadius.sm,
        borderWidth: 1,
        borderColor: theme.colors.error,
    },
});
